export default {
  TOGGLE_INFO_MODAL: 'toggleInfoModal',
  TOGGLE_DEFAULT_ERROR_MODAL: 'toggleDefaultErrorModal',
};



// WEBPACK FOOTER //
// ./src/app/shared/info-modal/constants/action-types.js